"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _CreditCardPlus = _interopRequireDefault(require("@rsuite/icon-font/lib/application/CreditCardPlus"));

// Generated by script, don't edit it please.
var CreditCardPlus = (0, _createSvgIcon["default"])({
  as: _CreditCardPlus["default"],
  ariaLabel: 'credit card plus',
  category: 'application',
  displayName: 'CreditCardPlus'
});
var _default = CreditCardPlus;
exports["default"] = _default;
module.exports = exports.default;